import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form'];
  static classes = ['errorm','hide'];
  static values = {validateurl: String, validateflag: String};
  formTargetConnected() {
    super.connect();
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.parentElement.querySelector("."+this.errormClass);
      }
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(event){
    const el = event.currentTarget;
    el.disabled = true;
    let errorMs = document.querySelectorAll("."+this.errormClass);
    errorMs.forEach(function (m) {
      m.textContent = "";
    });
    const formData = new FormData(this.formTarget);
    const allErrorE = document.getElementById("allError");
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(response != null && Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
          el.disabled = false;
        }else{
          const formTarget = this.formTarget
            allErrorE.innerHTML = '';
            allErrorE.classList.add(this.hideClass);
            formTarget.submit();
          }
      }
    });
  }

}
